// Initial State
const initialState = {
  orderTypes: [],
  error: null
};

// Action constants
const GET_ORDER_TYPES = 'GET_ORDER_TYPES';
const GET_ORDER_TYPES_SUCCESS = 'GET_ORDER_TYPES_SUCCESS';
const GET_ORDER_TYPES_FAILURE = 'GET_ORDER_TYPES_FAILURE';

// Action creators
export const getOrderTypes = () => {
  return {
    types: [GET_ORDER_TYPES, GET_ORDER_TYPES_SUCCESS, GET_ORDER_TYPES_FAILURE],
    payload: {
      request: {
        url: '/order-types',
        method: 'GET',
      }
    }
  };
};

const orderTypesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ORDER_TYPES_SUCCESS:
      return {
        ...state,
        orderTypes: action.payload.data.data
      };

    case GET_ORDER_TYPES_FAILURE:
      return {
        ...state,
        error: action.payload.data.error
      };

    default:
      return state;
  }
};

export default orderTypesReducer;
